import { Injectable } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';

@Injectable({
    providedIn: 'root',
})
export class UtilService {
    isMapLoad: boolean = false;
    constructor(
        private toast: HotToastService
    ) {}

        showToast(msg, isErr?) {
            if(isErr) {
                this.toast.error(msg);
            } else {
                this.toast.success(msg);
            }
        }

    createMapScript(key) {
        this.isMapLoad = true;
        let node = document.createElement('script');
        node.src =
            'https://maps.googleapis.com/maps/api/js?key=' +
            key +
            '&callback=initMap';
        node.type = 'text/javascript';
        node.async = true;
        document.getElementsByTagName('body')[0].appendChild(node);
    }

    initMap() {
        console.log('map script callback function');
    }

    hexToRgb(hex) {
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? parseInt(result[1], 16) +
                  ',' +
                  parseInt(result[2], 16) +
                  ',' +
                  parseInt(result[3], 16)
            : null;
    }

    abc() {}
}
